import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { localCopy } from 'tracked-toolbox';
import { service } from '@ember/service';

/**
 *
 * @param {String}          triggerClass
 * @param {String}          dropdownClass
 * @param {String}          viewPortSelector
 * @param {Array}           options
 * @param {Function}        setSelectedOptions
 * @param {String}          selectedOptions
 * @param {String}          noOptionSelectedText
 * @param {String}          optionAttr
 * @param {Boolean}         hasMorePages
 * @param {Boolean}         searchEnabled
 * @param {Boolean}         isDisabled
 * @param {Task}            searchTask
 * @param {Task}            loadMoreTask
 */
export default class InfiniteLoadMultiSelectDropdown extends Component {
  @service metrics;
  @tracked _EPSapi;
  @localCopy('args.selectedOptions') selectedOptions;

  @action
  onClose(_, event) {
    if (event.uniqueId) {
      return false;
    }
    return true;
  }

  @action
  selectOption(option) {
    const { setSelectedOptions, isMulti } = this.args;
    let selectedOptions = [];

    if (isMulti) {
      if (this.selectedOptions?.includes(option)) {
        // Deseleting an option
        selectedOptions = this.selectedOptions.filter((selected) => selected !== option);
      } else {
        selectedOptions = [...this.selectedOptions, option];
      }
    } else {
      selectedOptions = [option];
    }

    this.metrics.trackEvent('Selected option in infinite load multi select dropdown', {
      type: this.args.dropdownClass,
      selectedLength: selectedOptions.length,
    });

    setSelectedOptions(selectedOptions);
  }

  @action
  onDeselectAll() {
    this.metrics.trackEvent('Deselect all in infinite load multi select dropdown', { type: this.args.dropdownClass });
    this.args.setSelectedOptions([]);
  }

  @action
  onSelectAll() {
    this.metrics.trackEvent('Select all in infinite load multi select dropdown', {
      optionsLength: this.args.options.length,
      type: this.args.dropdownClass,
    });
    this.args.setSelectedOptions(this.args.options);
  }

  @action
  registerPowerSelectAPI(publicAPI) {
    this._EPSapi = publicAPI;
  }
}
